import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BottomNav from '../components/BottomNav';
import { Box } from '@mui/material';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  // Reset scroll position whenever location changes
  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <div className="flex flex-col h-screen bg-background-dark">
      {/* Navigation - responsive position */}
      <BottomNav />

      {/* Main content area */}
      <main ref={mainRef} className="flex-1 overflow-auto pb-20 md:pb-0 pt-16">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
